import moment from 'moment';
import useSetExport from '@components/export/useSetExport';

export const useSetTableExport = ({ data, columns, interval, type }) => {
  const headers = columns.map(({ title, dataKey }) => {
    return { title, key: dataKey, type: null };
  });

  const intervalStr = `(${moment(interval.from).format()} - ${moment(interval.to).format()})`;

  let widgetKey = '';
  let title = '';
  switch (type) {
    case 'rca':
      widgetKey = 'network-request-rca';
      title = 'Network Request Root Cause Hypothesis';
      break;
    default:
      widgetKey = 'network-request';
      title = 'Network Request';
      break;
  }

  useSetExport({
    pageKey: 'trends',
    sectionKey: 'dimensions-panel',
    widgetKey,
    widgetInfo: {
      title: `${title}: showing random 1k network requests ${intervalStr}`,
    },
    data,
    headers,
  });
};
